export const stockStatusOptions = [
  {
    label: 'Selalu Tersedia',
    value: 'AVAILABLE'
  },
  {
    label: 'Terbatas',
    value: 'LIMITED'
  },
  {
    label: 'Stok Habis',
    value: 'EMPTY'
  }
]
